import { render, staticRenderFns } from "./TopUpPayment.vue?vue&type=template&id=265521ba&scoped=true"
import script from "./TopUpPayment.vue?vue&type=script&lang=js"
export * from "./TopUpPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265521ba",
  null
  
)

export default component.exports